module.exports = __webpack_public_path__ + "static/media/image_1.1ea36a65.jpg";